import React from 'react';
import AppRouter from './screens/AppRouter';
import ReactResizeDetector from 'react-resize-detector';
import { BrowserRouter, HashRouter } from 'react-router-dom';

const BROWSER_HISTORY_PATHS = ['/trade-in/request'];

function shouldUseBrowserRouter() {
  const pathname = window.location.pathname.replace(/\/$/, '') || '/';
  return BROWSER_HISTORY_PATHS.some(
    (route) => pathname === route || pathname.startsWith(`${route}/`)
  );
}

class App extends React.Component {
  componentDidMount() {
    setTimeout(() => {
      const initialHeight = document.getElementById('root').offsetHeight;
      window.parent.postMessage(
        { widgetData: 'height', height: initialHeight },
        '*'
      );
    }, 500);
  }

  onResize(width, height) {    
    window.parent.postMessage({ widgetData: 'height', height: height }, '*');
  }

  render() {
    const Router = shouldUseBrowserRouter() ? BrowserRouter : HashRouter;

    return (
      <div>
        <ReactResizeDetector
          handleHeight
          onResize={this.onResize}
          querySelector={'#root'}
        />
        <Router>
          <AppRouter/>
        </Router>
      </div>
    );
  }
}

export default App;
